import React from 'react';
import { Layout, message, Modal, Icon, Button } from 'antd';
import NHContainerFrame from "../../common/NHContainerFrame/index";
import NHTable from "../../common/NHTable/index";
import getSize from "../../../utils/getSize";
import {hasAuth} from "../../../utils/NHCore";
const confirm = Modal.confirm;
import css from './index.css';

const { Content } = Layout;

export default class QueryStudents extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchParams: {},
            selectKey: '',
            showData: {}, //修改的数据
            showAdd: false,
            showListPage: true,
            isAdd: true,
            showOperationBtn: false,
        }
    }

    //搜索框条件值改变时调用的方法
    inputChange = (param) => {
        let searchParams = this.state.searchParams;
        let name = param.target.name;
        searchParams[name] = param.target.value;
        this.setState({
            searchParams: searchParams
        });
    }
    //查询操作
    onSearch = (e) => {
        this.refs.nhTable.filterTableData();
    }

    exportClickListener = (tar) => {
        tar.exportExcel('学生专业调整信息查询');
    };

    render() {
        let columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '70',
                cacheFixed: 'left'
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120',
                cacheFixed: 'left',
                search: 'input',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '100',
                cacheFixed: 'left',
                search: 'input',
                searchType:"input"
            }, {
                title: '考生号',
                dataIndex: 'KSH',
                width: '150',
                cacheFixed: 'left',
                search: 'input',
                searchType:"input"
            }, {
                title: '调整前学院',
                dataIndex: 'TZQBMMC',
                width: '200',
                search: 'input',
                searchType:"select"
            }, {
                title: '调整前专业',
                dataIndex: 'TZQZYMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"TZQBMMC"
            }, {
                title: '调整前班级',
                dataIndex: 'TZQBJMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"TZQZYMC"
            }, {
                title: '调整后学院',
                dataIndex: 'TZHBMMC',
                width: '200',
                search: 'input',
                searchType:"select"
            }, {
                title: '调整后专业',
                dataIndex: 'TZHZYMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"TZHBMMC"
            }, {
                title: '调整后班级',
                dataIndex: 'TZHBJMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"TZHZYMC"
            }, {
                title: '办理人',
                dataIndex: 'SHR',
                width: '100',
                search: 'input',
                searchType:"input"
            }, {
                title: '办理时间',
                dataIndex: 'SHSJ',
                width: '150',
                search: 'input',
                searchType:"input"
            }
        ];
        return (
            <div  className={css.main_right_content} style={{height: getSize().windowH - 220}}>
                    <div style={{width: '100%', height: '90%',}}>
                        <NHTable
                            ref='nhTable'
                            rowKey={record => record.PKID}
                            sign={"zhxg_yxxt_xszytzxx_queryPage"}
                            columns={columns}
                            initParams={this.state.searchParams}
                            rowSelectionChange={this.rowSelectionChange}
                            // rangeFilter={true}
                            checkbox={false}
                        >
                            <Button type="primary" ghost onClick={() => this.exportClickListener(this.refs.nhTable)}
                                    style={{marginLeft: 10}}>导出</Button>
                        </NHTable>
                    </div>
                        
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/zytzxx/xszytzxx.js